import type { RawComponent, Component } from '../types'
import bannerComponentParser from './Banner'
import blockQuoteComponentParser from './BlockQuote'
import { parser as buttonComponentParser } from 'content-components/_Primatives/Button/parser'
import calloutBoxComponentParser from './CalloutBox'
import contentHeaderComponentParser from './ContentHeader'
import dailyListComponentParser from './DailyList'
import faqModuleComponentParser from './FAQModule'
import featuredDailyArticleComponentParser from './FeaturedDailyArticle'
import headlineThreeComponentParser from './HeadlineThree'
import { parser as headlineTwoComponentParser } from 'content-components/_Primatives/Headlines/HeadlineTwo/parser'
import imageCardsComponentParser from './ImageCards'
import pageNotFoundComponentParser from './PageNotFound'
import quoteComponentParser from './Quote'
import tabMenuComponentParser from './TabMenu'
import textBlockComponentParser from './TextBlock'
import locationCourseCardsComponentParser from './LocationCourseCards'
import fullWidthPromoComponentParser from './FullWidthPromo'
import articleListParser from './ArticleList'
import formModuleComponentParser from './FormModule'
import findACourseModuleComponentParser from './FindACourseModule'
import searchPageComponentParser from './SearchPage'
import onrampMailingListCTAComponentParser from './OnrampMailingListCTA'
import onrampCTAComponentParser from './OnrampCTA'
import messageCardsComponentParser from './MessageCards'
import numericListPromoComponentParser from './NumericListPromo'
import equipmentCTAComponentParser from './EquipmentCTA'
import fullWidthPromoWithCardsComponentParser from './FullWidthPromoWithCards'
import flexibleTableComponentParser from './FlexibleTable'
import orderConfirmationComponentParser from './OrderConfirmation'
import courseCertificationModuleComponentParser from './CourseCertificationModule'
import featuredPartnersParser from './FeaturedPartners'
import affiliateStepsCardsParser from './AffiliateStepsCards'
import preferredCoursesParser from './PreferredCourses'
import { parser as simpleCTAParser } from 'content-components/SimpleCTA/parser'
import { parser as stickyCTAParser } from 'content-components/StickyCTA/parser'
import { parser as quoteListParser } from 'content-components/QuoteList/parser'
import errorLogging from 'services/error-logging'

export default function parseComponent(
  rawComponent: RawComponent,
): Component | undefined {
  switch (rawComponent.acfFcLayout) {
    case 'featured_partners':
      return featuredPartnersParser(rawComponent)
    case 'course_certification_module':
      return courseCertificationModuleComponentParser(rawComponent)
    case 'article_list':
      return articleListParser(rawComponent)
    case 'full_width_promo':
      return fullWidthPromoComponentParser(rawComponent)
    case 'location_course_cards':
      return locationCourseCardsComponentParser(rawComponent)
    case 'button':
      return buttonComponentParser(rawComponent)
    case 'banner':
      return bannerComponentParser(rawComponent)
    case 'image_cards':
      return imageCardsComponentParser(rawComponent)
    case 'tab_menu_component':
      return tabMenuComponentParser(rawComponent)
    case 'featured_daily_article':
      return featuredDailyArticleComponentParser(rawComponent)
    case 'daily_list':
      return dailyListComponentParser(rawComponent)
    case 'headline_three':
      return headlineThreeComponentParser(rawComponent)
    case 'headline_two':
      return headlineTwoComponentParser(rawComponent)
    case 'block_quote':
      return blockQuoteComponentParser(rawComponent)
    case 'faq_module':
      return faqModuleComponentParser(rawComponent)
    case 'form_module':
      return formModuleComponentParser(rawComponent)
    case 'text_block':
      return textBlockComponentParser(rawComponent)
    case 'page_not_found':
      return pageNotFoundComponentParser(rawComponent)
    case 'content_header':
      return contentHeaderComponentParser(rawComponent)
    case 'callout_box':
      return calloutBoxComponentParser(rawComponent)
    case 'full_width_quote':
      return quoteComponentParser(rawComponent)
    case 'find_a_course_module':
      return findACourseModuleComponentParser(rawComponent)
    case 'search_page':
      return searchPageComponentParser(rawComponent)
    case 'onramp_mailing_list_cta':
      return onrampMailingListCTAComponentParser(rawComponent)
    case 'onramp_cta':
      return onrampCTAComponentParser(rawComponent)
    case 'message_cards':
      return messageCardsComponentParser(rawComponent)
    case 'numeric_list_promo':
      return numericListPromoComponentParser(rawComponent)
    case 'equipment_cta':
      return equipmentCTAComponentParser(rawComponent)
    case 'full_width_promo_with_cards':
      return fullWidthPromoWithCardsComponentParser(rawComponent)
    case 'flexible_table':
      return flexibleTableComponentParser(rawComponent)
    case 'order_confirmation':
      return orderConfirmationComponentParser(rawComponent)
    case 'step_cards':
      return affiliateStepsCardsParser(rawComponent)
    case 'preferred_course_cards':
      return preferredCoursesParser(rawComponent)
    case 'simple_cta':
      return simpleCTAParser(rawComponent)
    case 'sticky_cta':
      return stickyCTAParser(rawComponent)
    case 'quote_list':
      return quoteListParser(rawComponent)
    default:
      errorLogging(
        new Error(`missing component parser for ${rawComponent.acfFcLayout}`),
        { rawComponent },
      )
      return
  }
}
